"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createNetworkMonitor = void 0;
const http_interfaces_1 = require("../types/http.interfaces");
const error_interfaces_1 = require("../types/error.interfaces");
const subject_1 = require("../utilities/subject");
// Naming values for clarity
const ONLINE = true;
const OFFLINE = false;
// TASK #1109893: Track EM resources
/**
 * Online state Subject
 */
const isOnlineSubject = new subject_1.Subject(ONLINE /* Online by default */);
/**
 * Analyses responses and any errors for network-related issues and
 * provides an API to monitor network state.
 * @param context - global services
 */
const createNetworkMonitor = () => {
    /**
     * Get current online state
     */
    const isOnline = () => isOnlineSubject.value;
    /**
     * Set new online state when different from current state
     * @param newState [boolean] Is network online
     */
    const setOnlineState = (newState) => isOnlineSubject.onNext(newState);
    /**
     * Analyze response and set network state accordingly
     * @param response [IResponse] Network response
     */
    const processResponse = (response) => {
        if (response.status !== undefined &&
            response.status !== http_interfaces_1.Status.NOT_MODIFIED && // cached response
            response.status !== http_interfaces_1.Status.GATEWAY_TIMEOUT) {
            // server responded
            setOnlineState(ONLINE);
        }
    };
    /**
     * Analyze response error
     * @param error
     */
    const processResponseError = (error) => {
        if (!error) {
            // doesn't indicate whether network is offline
        }
        else if (error.reason === error_interfaces_1.ErrorReason.RejectHttpError) {
            // it's not server-related error
            // fetch failed
            setOnlineState(OFFLINE);
        }
        else if (error.serverResponse) {
            setOnlineState(ONLINE);
        }
        else {
            // unknown error or expected request termination (Timeout, aborted request, invalid params, etc)
        }
    };
    return {
        networkMonitor: {
            processResponse,
            processResponseError,
        },
        networkState: {
            observeIsOnline: () => isOnlineSubject.observable,
            isOnline,
        },
    };
};
exports.createNetworkMonitor = createNetworkMonitor;
